<form [formGroup]="form" class="container">
  <app-titulo>Abertura de Caixa</app-titulo>
  <div class="inputs">
    <app-input
      type="money"
      label="Insira o valor inicial de abertura:"
      name="VL_ABTR_CAIX"
      formControlName="VL_ABTR_CAIX"
      placeholder="Digite aqui"></app-input>
  </div>
  <div class="buttons">
    <app-botao text="Cancelar" bgColor="#B91C1C" (click)="onCancelar()" />
    <app-botao
      text="Confirmar"
      [bgColor]="!form.valid ? '' : '#059669'"
      (click)="postAbertura()"
      [disabled]="!form.valid || isLoading" />
  </div>
</form>

<app-loader *ngIf="isLoading" />
